export default __webpack_public_path__ + "static/rfid-cbde17b6f10584997415918eaffcd800.jpg";